// src/components/GroupsForm.js

import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeachers } from "../actions/teacherActions";
import { fetchGroupById } from "../actions/groupActions";
import { useParams } from "react-router-dom";

const GroupsForm = ({ open, onClose, onSubmit, group }) => {
  const dispatch = useDispatch();
  const { groupId } = useParams();

  // State variables
  const [groupName, setGroupName] = useState(group ? group.group_name : "");
  const [groupDescription, setGroupDescription] = useState(
    group ? group.description : ""
  );
  const [selectedTeachers, setSelectedTeachers] = useState(
    group ? group.teacher_ids || [] : []
  );

  // Fetch teachers from Redux store
  const teachers = useSelector((state) => state.teacher.teachersList || []);
  const groupDetails = useSelector((state) => state.groups.currentGroup);

  useEffect(() => {
    // Fetch the list of teachers
    dispatch(fetchTeachers());

    if (groupId) {
      // Fetch group details if editing
      dispatch(fetchGroupById(groupId));
    }
  }, [dispatch, groupId]);

  useEffect(() => {
    if (group) {
      setGroupName(group.group_name || "");
      setGroupDescription(group.description || "");
      setSelectedTeachers(group.teacher_ids || []);
    } else {
      setGroupName("");
      setGroupDescription("");
      setSelectedTeachers([]);
    }
  }, [group]);

  useEffect(() => {
    if (groupDetails && groupId) {
      // Populate state variables with group details
      setGroupName(groupDetails.group_name);
      setGroupDescription(groupDetails.description);
      setSelectedTeachers(groupDetails.teacher_ids || []);
    }
  }, [groupDetails, groupId]);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    const groupData = {
      group_name: groupName,
      description: groupDescription,
      teacher_ids: selectedTeachers,
    };

    onSubmit(groupData);
  };

  // Handle teacher selection
  const handleTeacherChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedTeachers(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{groupId ? "Editează grupul" : "Adaugă grup"}</DialogTitle>
      <DialogContent>
        {/* <form onSubmit={handleSubmit}> */}
        <TextField
          label="Nume Grupă"
          fullWidth
          margin="normal"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          required
        />
        <TextField
          label="Descriere"
          fullWidth
          margin="normal"
          multiline
          rows={4}
          value={groupDescription}
          onChange={(e) => setGroupDescription(e.target.value)}
        />
        <FormControl fullWidth margin="normal">
          <InputLabel id="teachers-label">Atribuie Profesori</InputLabel>
          <Select
            labelId="teachers-label"
            multiple
            value={selectedTeachers}
            onChange={handleTeacherChange}
            renderValue={(selected) =>
              teachers
                .filter((teacher) => selected.includes(teacher.user_id))
                .map((teacher) => teacher.name)
                .join(", ")
            }
          >
            {teachers.map((teacher) => (
              <MenuItem key={teacher.user_id} value={teacher.user_id}>
                <Checkbox
                  checked={selectedTeachers.includes(teacher.user_id)}
                />
                <Typography>{teacher.name}</Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Anulează</Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          {groupId ? "Update Group" : "Create Group"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupsForm;
